module.exports = __webpack_public_path__ + "media/promo/hochland/images/p1-6184e729b9bebaf0cad9923517f53134.png";